// extracted by mini-css-extract-plugin
export default {"navBar":"Header_navBar__3LZYM","title":"Header_title__tW1Nh","telega":"Header_telega__8SOe-"};